var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-app container_ inner-app"},[_c('ContactPage',{staticClass:"inner-app-content"}),_c('transition',{attrs:{"name":"modal-fade"}},[(_vm.isModalRoute)?_c('Modal',{attrs:{"showCloseBtn":true,"fullScreen":true},on:{"close":_vm.closeModal}},[_c('router-view')],1):_vm._e()],1),(_vm.isLoading && false)?_c('Loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }